module.exports = __webpack_public_path__ + "static/yellow_flash_bk-2ffbac4ec1e25bd7a87b9294cc524507.png";